/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export { default as DropzoneDefault } from './dropzone-default.story';
export { default as DropzoneCsvFiles } from './dropzone-csv-files.story';
export { default as DropzoneCustomExtensions } from './dropzone-custom-extensions.story';
export { default as DropzoneLoadingProgress } from './dropzone-loading-progress.story';
export { default as DropzoneDisabled } from './dropzone-disabled.story';
export { default as DropzoneFull } from './dropzone-full.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import DropzoneCsvFilesSourceRaw from './dropzone-csv-files.story.tsx?raw';
import DropzoneCustomExtensionsSourceRaw from './dropzone-custom-extensions.story.tsx?raw';
import DropzoneDefaultSourceRaw from './dropzone-default.story.tsx?raw';
import DropzoneDisabledSourceRaw from './dropzone-disabled.story.tsx?raw';
import DropzoneFullSourceRaw from './dropzone-full.story.tsx?raw';
import DropzoneLoadingProgressSourceRaw from './dropzone-loading-progress.story.tsx?raw';

export const DropzoneDefaultSource = removeLicenseHeader(
  DropzoneDefaultSourceRaw,
);
export const DropzoneCsvFilesSource = removeLicenseHeader(
  DropzoneCsvFilesSourceRaw,
);
export const DropzoneCustomExtensionsSource = removeLicenseHeader(
  DropzoneCustomExtensionsSourceRaw,
);
export const DropzoneLoadingProgressSource = removeLicenseHeader(
  DropzoneLoadingProgressSourceRaw,
);
export const DropzoneDisabledSource = removeLicenseHeader(
  DropzoneDisabledSourceRaw,
);
export const DropzoneFullSource = removeLicenseHeader(DropzoneFullSourceRaw);
